import React from 'react';

export const ModuleIframe = ({ url }) => {
  return (
    <div className="container module-iframe__wrapper">
      <iframe className="module-iframe" src={url} />
    </div>
    
  )
} 